export function formatMotora(values) {
    return {
        idMotorista: values.idMotorista,
        nome: values.nome,
        telefone: values.telefone,
        nomeEmergencia: values.nomeEmergencia,
        telefoneEmergencia: values.telefoneEmergencia,
        numeroDocumento: values.numeroDocumento,
        tipoDocumento: values.tipoDocumento,
        frota: values.frota,
        motivo: values.motivo ?? "",
        bloqueado: values.bloqueado ?? false,
        rg: values.rg,
        endereco: {
            bairro: values.bairro,
            rua: values.rua,
            numero: parseInt(values.numero),
            complemento: values.complemento ?? "",
            cep: values.cep,
            cidade: values.cidade,
            latitude: values.latitude,
            longitude: values.longitude
        },
    }
}